import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class CoreEventActivityService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/core_events/%(event_id)s/activities`);
  }

  // Upsert one attendee's registration / attendance / signature on an activity.
  setAttendance(activityId: number, attendeeId: number, payload: any, urlParams: any = {}): Observable<any> {
    const url = `${sprintf(this.baseUrl, urlParams)}/${activityId}/attendance/${attendeeId}`;
    return this.http.put<any>(url, payload);
  }
}
